(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7903,4194,8691],{

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 36484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckContent; }
/* harmony export */ });
/* harmony import */ var _Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59699);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CheckContent(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "mt-2 flex items-start first:mt-0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_0__/* .FaCheckCircle */ .F, {
        size: 16,
        className: "mr-2 mt-1 text-bbc-brand-600"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      dangerouslySetInnerHTML: {
        __html: data
      },
      className: ""
    })]
  });
}

/***/ }),

/***/ 83719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56727);
/* harmony import */ var components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["data", "children", "activeIndex", "labelValue", "buttonExtendedClass"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Dropdown = function Dropdown(_ref) {
  var data = _ref.data,
      _children = _ref.children,
      activeIndex = _ref.activeIndex,
      labelValue = _ref.labelValue,
      buttonExtendedClass = _ref.buttonExtendedClass,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox */ .Ri, _objectSpread(_objectSpread({}, props), {}, {
    as: "div",
    className: props.className ? props.className : " dropdown-default",
    onChange: props.onChange ? props.onChange : function () {},
    children: function children(_ref2) {
      var open = _ref2.open;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Button */ .Ri.Button, {
          className: "relative w-full select-none pl-4  pr-9 text-left font-medium leading-6 h-full".concat(buttonExtendedClass ? " ".concat(buttonExtendedClass) : ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: open ? "text-bbc-brand-700" : "text-bbc-brand-800",
            children: labelValue && labelValue !== "" ? labelValue : activeIndex
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_2__/* .FiChevronDown */ .b, {
            className: "absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-brand-500  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
            size: 20
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .uT, {
          leave: "transition-all duration-200 ease-out",
          leaveFrom: "transform  opacity-50",
          leaveTo: "transform  opacity-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Options */ .Ri.Options, {
            className: "absolute z-10 mt-1 w-full select-none ".concat(props.optionsClass),
            style: props.optionsStyle,
            as: "div",
            children: _children ? _children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: " rounded-b-xl  bg-white pb-2",
              children: Array.isArray(data) && data.map(function (item, index) {
                if (item.title != activeIndex) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Listbox.Option */ .Ri.Option, {
                    value: item.uri,
                    as: "div",
                    className: "block cursor-pointer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_ButtonNew__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                      as: "a",
                      variant: "ghost",
                      href: item.uri,
                      useRouter: true,
                      btnDisplay: "block",
                      btnTextColor: "text-bbc-brand-700 hover:text-bbc-brand-500",
                      btnPadding: "px-4 py-2",
                      btnTextWeight: "font-normal",
                      children: item.title
                    })
                  }, index);
                }

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {});
              })
            })
          })
        })]
      });
    }
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.defaultProps = {
  labelValue: null,
  data: [],
  buttonExtendedClass: null,
  activeIndex: "No thing to choose"
};
/** ========== */

/***/ }),

/***/ 59699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FaCheckCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheckCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 90846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GrNext; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function GrNext(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "7 2 17 12 7 22"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 80703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ GrPrevious; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function GrPrevious(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "7 2 17 12 7 22",
        "transform": "matrix(-1 0 0 1 24 0)"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 88279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72713);
/* harmony import */ var common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12453);
/* harmony import */ var common_fetch_post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92559);
/* harmony import */ var common_trigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62951);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7778);
/* harmony import */ var components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66865);
/* harmony import */ var components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78762);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/** ========== */




var FormCountry = function FormCountry(_ref) {
  var country_id = _ref.country_id;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_3__/* .ToastContext */ .uL),
      openAlert = _useContext.openAlert;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                dataSend = _objectSpread({}, data);
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.company_country_id = country_id;

                try {
                  (0,common_fetch_post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/question"),
                    data: dataSend,
                    token: token
                  }).then(function (res) {
                    if (res.state) {
                      (0,common_trigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("contact_form", dataSend, "Contact form");
                      openAlert(2000, "success");
                      reset();
                    } else {
                      openAlert(3000, "error");
                      console.log("error");
                    }
                  })["catch"](function (e) {
                    openAlert(3000, "error");
                    console.log("error", e);
                  });
                } catch (e) {
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        register: register,
        errors: errors,
        name: "first_name",
        placeholder: "Name*",
        requiredText: "Name is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputEmail */ .j7, {
        register: register,
        errors: errors
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        as: "textarea",
        register: register,
        errors: errors,
        name: "message",
        placeholder: "Message*",
        requiredText: "Message is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "flex flex-wrap items-center justify-between",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 mb-6 text-center lg:col-auto  lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "inline-block",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: recaptchaRef,
            className: "mx-auto w-max"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 text-center lg:col-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          type: "submit",
          style: {
            minWidth: "170px"
          },
          disabled: isSubmitting,
          children: [isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__/* .BiLoaderAlt */ .s, {
            className: "mr-2 inline-block animate-spin",
            size: 20
          }), "Send Your Message"]
        })
      })]
    })]
  });
};
/** ========== */


var FormCountries = function FormCountries(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      descriptionClass = _ref3.descriptionClass,
      contentBottom = _ref3.contentBottom,
      country_id = _ref3.country_id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: "rounded-3xl bg-white px-3  py-6 lg:px-10 lg:py-[50px]",
    style: {
      boxShadow: "0px 16px 40px rgba(181, 181, 181, 0.25)"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-center lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
      className: "".concat(descriptionClass ? descriptionClass : "mb-6 text-center lg:mb-10"),
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormCountry, {
        country_id: country_id
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      children: contentBottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormCountries);
FormCountries.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {}
};
/** ========== */

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 82385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_atoms_Icon_gr_GrNext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90846);
/* harmony import */ var components_atoms_Icon_gr_GrPrevious__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80703);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31857);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["thetitle", "navResponsiveClass", "paginationResponsiveClass", "children", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".bbc-slide-pagination",
    clickable: true,
    bulletClass: "bbc-pagination-bullet"
  },
  navigation: {
    nextEl: ".bbc-button-next",
    prevEl: ".bbc-button-prev"
  },
  slidesPerView: 3,
  spaceBetween: 30,
  // Responsive breakpoints
  breakpoints: {
    1280: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerGroup: 2
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1
    },
    320: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
      navigation: true
    }
  }
};
/** ========== */

var PostSlider = function PostSlider(_ref) {
  var thetitle = _ref.thetitle,
      navResponsiveClass = _ref.navResponsiveClass,
      paginationResponsiveClass = _ref.paginationResponsiveClass,
      children = _ref.children,
      description = _ref.description,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
    className: "relative",
    children: [thetitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
      children: thetitle
    }), description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread(_objectSpread({
      modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl],
      className: " !p-4"
    }, swiper), props), {}, {
      children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-slide-pagination relative  block pt-6 text-center ".concat(props.showPaginationClass || " lg:invisible", " ").concat(paginationResponsiveClass)
      })]
    })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex ".concat(navResponsiveClass),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-button-prev ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), "  ").concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnPrev), " "),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Icon_gr_GrPrevious__WEBPACK_IMPORTED_MODULE_7__/* .GrPrevious */ .U, {
          size: 18,
          className: "text-red-400"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "bbc-button-next ".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn), "  ").concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnNext), " "),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Icon_gr_GrNext__WEBPACK_IMPORTED_MODULE_6__/* .GrNext */ .U, {
          size: 18,
          className: "text-red-400"
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PostSlider);
PostSlider.defaultProps = {
  thetitle: null
};
/** ========== */

/***/ }),

/***/ 95183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







/** ========== */




var RequiredDocument = function RequiredDocument(_ref) {
  var _data$content;

  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      backgroundImage = _ref.backgroundImage;
  var checkBtnRight = data.button_image && Object.keys(data.button_image).length > 0;

  var renderButton = function renderButton() {
    var button = data.button;

    if (button) {
      if (button.type === "contact-us") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6 text-center lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: button.link,
            className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
            children: button.text
          })
        });
      }

      if (button.type === "talk-to") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "button",
            onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return Tawk_API.toggle();

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      console.error();

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5]]);
            })),
            children: button.text
          })
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mt-6 text-center lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: button.link,
          className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
          children: button.text
        })
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "relative ".concat(sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container relative z-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat(checkBtnRight ? "lg:col-8" : "lg:col-12"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
          }), (data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && data.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "mb-2 text-white ",
                dangerouslySetInnerHTML: {
                  __html: item.title
                }
              }), item.listContent && item.listContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                className: "lg:mb-2",
                children: item.listContent.map(function (element, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
                    className: "   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: element.text
                      }
                    }), element.content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                      children: element.content.map(function (element, index) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                          className: "relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']",
                          children: element
                        }, index);
                      })
                    })]
                  }, i);
                })
              })]
            }, index);
          }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "m-0 text-white",
            dangerouslySetInnerHTML: {
              __html: data.note
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "text-center lg:text-left",
            children: renderButton()
          })]
        }), checkBtnRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "lg:col-4",
          children: data.button_image.type && data.button_image.type === "post" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: data.button_image.width || 350,
              height: data.button_image.height || 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: 350,
              height: 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      src: backgroundImage,
      width: 1920,
      height: 737,
      className: "h-full w-full",
      wrapper: {
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RequiredDocument);
RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 18691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["className", "description", "imgAlt", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var StepSlider = function StepSlider(_ref) {
  var className = _ref.className,
      description = _ref.description,
      imgAlt = _ref.imgAlt,
      data = _ref.data,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: " pt-10 lg:pt-24 ".concat(className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        text: data.title,
        as: "h2",
        className: " mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-4xl"
      }), description ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("p", {
        className: "mb-10 text-center",
        children: [" ", description]
      }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "row justify-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 mb-6 flex items-center justify-center lg:col-4 lg:mb-0 lg:justify-start",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            src: "/assets/images/offshore/country/bvi/bank_account-bvi.png",
            alt: imgAlt,
            width: 351,
            height: 350
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-3 flex items-center justify-center lg:col-1 lg:order-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "swiper-pagination-custom flex h-6 items-end justify-center lg:h-[370px] lg:w-fit lg:flex-col lg:pr-4"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-2 self-center lg:col-6 lg:order-3 ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread({
              slidesPerView: 1,
              spaceBetween: 30,
              mousewheel: true,
              allowTouchMove: true,
              effect: "fade",
              fadeEffect: {
                crossFade: true
              },
              pagination: {
                el: ".swiper-pagination-custom",
                clickable: true,
                bulletClass: "pagination-bullet ",
                bulletActiveClass: "pagination-bullet-active bbc-pagination-bullet-active"
              },
              breakpoints: {
                320: {
                  allowTouchMove: true
                },
                1024: {
                  allowTouchMove: true
                }
              },
              modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Mousewheel */ .Gk, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .EffectFade */ .xW],
              className: "mySwiper"
            }, props), {}, {
              children: data.steps && data.steps.length > 0 && data.steps.map(function (step, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                  className: "h-auto",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "step-slider h-full rounded-xl bg-transparent p-0 lg:bg-white lg:px-10 lg:pb-10 lg:pt-6",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      as: "h3",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-1 block text-lg font-medium text-bbc-brand-700",
                        children: step.index
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-6 block text-lg font-semibold text-bbc-brand-600 lg:text-2xl",
                        children: step.titleStep
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                      className: "text-bbc-gray",
                      dangerouslySetInnerHTML: {
                        __html: step.description
                      }
                    })]
                  })
                }, index);
              })
            }))
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (StepSlider);
StepSlider.defaultProps = {
  className: ""
};

/***/ }),

/***/ 79527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_SupportedCountries; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./components/atoms/Dropdown/index.js
var Dropdown = __webpack_require__(83719);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/fi/FiExternalLink.js

function FiExternalLink(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "15 3 21 3 21 9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "14",
        "x2": "21",
        "y2": "3"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/SupportedCountries/index.js







/** ========== */





var SupportedCountries = function SupportedCountries(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      descriptionBottom = _ref.descriptionBottom,
      id = _ref.id;

  var _useState = (0,react.useState)(data[0]),
      location = _useState[0],
      setLocation = _useState[1];

  var largestObjLength = data.reduce(function (a, b) {
    return a.listCountries.length > b.listCountries.length ? a : b;
  }).listCountries.length;
  var minHeight = 88 + largestObjLength * 36;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      id: id,
      className: " py-10 text-white lg:py-20 ",
      style: {
        background: "#011221"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " relative mb-6 bg-bottom",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container relative z-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "mb-6 text-center text-bbc-30px font-semibold lg:text-bbc-40px",
            children: title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6 text-center lg:mb-10",
            children: description
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "relative z-10 hidden  bg-bottom p-16 bg-blend-color lg:block",
            style: {
              background: "#ffffff1a",
              borderRadius: "20px"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row",
              children: [data.length > 0 && data.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-4 mb-6 ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "h-full border-b pb-6",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                      as: "h3",
                      text: item.label,
                      className: "text-lg font-semibold"
                    })
                  })
                }, index);
              }), data.length > 0 && data.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-4",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: item.listCountries.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      className: "text-lg",
                      children: item.listCountries.map(function (element, i) {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                          className: "".concat(i > 0 ? "mt-2" : ""),
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
                            href: element.uri,
                            className: "group text-bbc-secondary-300  transition-colors duration-100 hover:text-bbc-yellow-500",
                            children: [element.text, /*#__PURE__*/(0,jsx_runtime.jsx)(FiExternalLink, {
                              size: 16,
                              className: "relative -left-4 ml-2 inline-block opacity-0 transition-all  duration-200 group-hover:left-0 group-hover:opacity-100 "
                            })]
                          })
                        }, i);
                      })
                    })
                  })
                }, index);
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative  px-3 py-4 bg-blend-color  ",
              style: {
                minHeight: minHeight,
                background: "#ffffff1a",
                borderRadius: "20px"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                className: "relative h-full w-auto text-bbc-brand-700",
                buttonExtendedClass: "font-semibold text-lg leading-7 py-2.5 rounded-[14px] bg-white",
                labelValue: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "truncate text-bbc-yellow-500",
                  children: location.label
                }),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "overflow-hidden rounded-xl shadow-md",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "max-h-40 overflow-auto bg-white text-lg",
                    children: data.map(function (item, itemIdx) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                        className: "list-none",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "flex cursor-pointer items-center gap-x-1 px-4 py-2 ".concat(location.value === item.value ? "bg-bbc-primary text-white" : "hover:bg-bbc-primary hover:bg-opacity-40"),
                          onClick: function onClick() {
                            return setLocation(item);
                          },
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "truncate",
                            children: item.label
                          })
                        })
                      }, itemIdx);
                    })
                  })
                })
              }), (location === null || location === void 0 ? void 0 : location.listCountries.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "mt-4",
                children: location.listCountries.map(function (element, i) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "".concat(i > 0 ? "mt-2" : "", " text-lg font-medium"),
                    style: {
                      opacity: "0.9"
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
                      href: element.uri,
                      className: "group text-bbc-secondary-300  transition-colors duration-100 hover:text-bbc-yellow-500",
                      children: [element.text, /*#__PURE__*/(0,jsx_runtime.jsx)(FiExternalLink, {
                        size: 16,
                        className: "relative -left-4 ml-2 inline-block opacity-0 transition-all  duration-200 group-hover:left-0 group-hover:opacity-100 "
                      })]
                    })
                  }, i);
                })
              })]
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/common/map-supported-mobile.png",
          width: 375,
          height: 446,
          className: "absolute left-0 right-0 bottom-0 -z-0 ml-auto mr-auto lg:hidden",
          alt: "bg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/common/map-supported.png",
          width: 955,
          height: 521,
          className: "absolute left-0 right-0 -bottom-3 -z-0 ml-auto mr-auto hidden lg:block ",
          alt: "bg"
        })]
      }), descriptionBottom]
    })
  });
};

/* harmony default export */ var organisms_SupportedCountries = (SupportedCountries);
SupportedCountries.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 67370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wave; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);

var _excluded = ["sectionTop", "sectionBottom", "children", "srcTop", "srcBottom", "imgWidthTop", "imgHeightTop", "imgWidthBottom", "imgHeightBottom", "background", "heightBottom"];



function Wave(_ref) {
  var sectionTop = _ref.sectionTop,
      sectionBottom = _ref.sectionBottom,
      children = _ref.children,
      srcTop = _ref.srcTop,
      srcBottom = _ref.srcBottom,
      imgWidthTop = _ref.imgWidthTop,
      imgHeightTop = _ref.imgHeightTop,
      imgWidthBottom = _ref.imgWidthBottom,
      imgHeightBottom = _ref.imgHeightBottom,
      background = _ref.background,
      heightBottom = _ref.heightBottom,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var customStyle = function customStyle() {
    if (props.style && Object.keys(props.style).length > 0) {
      return props.style;
    }

    return {
      top: "100px"
    };
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "relative overflow-hidden",
      children: [sectionTop && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "container relative z-10",
        children: sectionTop
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "absolute hidden h-full  w-full lg:block ",
        style: customStyle(),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          src: srcTop,
          width: imgWidthTop || 1920,
          height: imgHeightTop || 125,
          className: "w-full",
          wrapper: {
            className: " w-full hidden lg:block"
          },
          alt: "Wave bottom"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "".concat(background, " absolute z-0 hidden h-full  w-full lg:block")
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: "".concat(background),
      children: children
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: " lg:relative  lg:overflow-hidden",
      children: [sectionBottom && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: " relative z-10 p-1.5 pb-10 lg:container lg:pb-20",
        children: sectionBottom
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "absolute top-0 hidden h-full w-full lg:block",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "".concat(background, " ").concat(heightBottom, " top-0  hidden w-full lg:block")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
          className: "relative  z-0 hidden lg:block ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
            src: srcBottom,
            width: imgWidthBottom || 1920,
            height: imgHeightBottom || 125,
            className: "w-full",
            wrapper: {
              className: " w-full  hidden lg:block"
            },
            alt: "Wave bottom"
          })
        })]
      })]
    })]
  });
}

/***/ }),

/***/ 58722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ organisms_WhatMakeUsDifferent; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(9846);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/Index.module.scss
var Index_module = __webpack_require__(81131);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/CardMakeDifferent.js







function CardMakeDifferent(_ref) {
  var title = _ref.title,
      description = _ref.description,
      src = _ref.src,
      alt = _ref.alt,
      rowReverse = _ref.rowReverse,
      listWithIcon = _ref.listWithIcon,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row justify-center ".concat(rowReverse && "flex-reverse" || ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      loading: "lazy",
      src: src,
      width: width || 540,
      height: height || 540,
      className: "h-auto w-full",
      wrapper: {
        className: "lg:col-6 flex items-center justify-center"
      },
      alt: alt
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " justify-center lg:col-6 lg:flex lg:flex-col",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:pr-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          as: "h3",
          className: " mt-6 text-lg font-semibold text-bbc-brand-700 lg:mt-0 lg:text-bbc-30px",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "mt-4 inline-block rounded-full lg:mt-6 ".concat((Index_module_default()).line, " ")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:text-normal mt-4",
          children: Array.isArray(description) ? description.map(function (item, idx) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "font-semibold",
                children: item.content
              }), item.listWithIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mt-2 mb-6",
                children: item.listWithIcon.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                    data: item
                  }, index);
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
            }, idx);
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [description, listWithIcon ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-3",
              children: listWithIcon.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                  data: item
                }, index);
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})]
          })
        })]
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/WMUDSlider.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var PostSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 4194).then(__webpack_require__.bind(__webpack_require__, 82385));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82385)];
    },
    modules: ["../components/organisms/WhatMakeUsDifferent/WMUDSlider.js -> " + "components/organisms/PostSlider"]
  }
});

var WMUDSlider = function WMUDSlider(_ref) {
  var data = _ref.data;
  var swiper = {
    direction: "vertical",
    preloadImages: false,
    lazy: true,
    autoHeight: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    speed: 800,
    fadeEffect: {
      crossFade: true
    },
    virtualTranslate: true,
    effect: "fade",
    mousewheel: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletClass: "bbc-pagination-bullet block my-1",
      bulletActiveClass: "bbc-pagination-bullet-active h-10 w-2.5"
    },
    slidesPerView: "auto",
    spaceBetween: 0
  };

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container h-auto overflow-auto lg:h-[550px] lg:overflow-hidden",
    children: screen === "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: " relative ",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        modules: [swiper_esm/* Navigation */.W_, swiper_esm/* Pagination */.tl, swiper_esm/* Autoplay */.pt, swiper_esm/* Mousewheel */.Gk, swiper_esm/* EffectFade */.xW]
      }, swiper), {}, {
        children: [Array.isArray(data) && data.length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: " flex text-left",
              style: {
                height: "550px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
                title: item.title,
                description: item.description,
                src: item.img_src,
                width: item.width,
                height: item.height,
                alt: item.img_alt,
                listWithIcon: item.listWithIcon
              })
            })
          }, index);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bbc-slide-pagination absolute right-0 z-10 -translate-y-1/2 pt-6",
          style: {
            top: "16rem"
          }
        })]
      }))
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider, {
      navigation: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 50
        }
      },
      children: Array.isArray(data) && data.length > 0 && data.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-full ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
              title: item.title,
              description: item.description,
              src: item.img_src,
              alt: item.img_alt,
              width: item.width,
              height: item.height,
              rowReverse: true,
              listWithIcon: item.listWithIcon
            })
          })
        }, index);
      })
    })
  });
};

/* harmony default export */ var WhatMakeUsDifferent_WMUDSlider = (WMUDSlider);
;// CONCATENATED MODULE: ./components/organisms/WhatMakeUsDifferent/index.js


var _excluded = ["data", "title", "ebookImage"];

function WhatMakeUsDifferent_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function WhatMakeUsDifferent_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WhatMakeUsDifferent_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WhatMakeUsDifferent_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var WhatMakeUsDifferent = function WhatMakeUsDifferent(_ref) {
  var data = _ref.data,
      title = _ref.title,
      ebookImage = _ref.ebookImage,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", WhatMakeUsDifferent_objectSpread(WhatMakeUsDifferent_objectSpread({}, props), {}, {
    className: props.className || "bg-wmud py-12 ",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "bbc-title mb-10 px-4 text-center lg:px-0"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overflow-hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        classNamePrefix: "wmud-lazyload",
        placeholder: data.length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardMakeDifferent, {
            title: item.title,
            description: item.description,
            src: item.img_src,
            width: item.width,
            height: item.height,
            alt: item.img_alt,
            listWithIcon: item.listWithIcon
          }, index);
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent_WMUDSlider, {
          data: data,
          ebookImage: ebookImage
        })
      })
    })]
  }));
};

/* harmony default export */ var organisms_WhatMakeUsDifferent = (WhatMakeUsDifferent);

/***/ }),

/***/ 60917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/PostSlider/index.js
var PostSlider = __webpack_require__(82385);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/StepSlider/index.js
var StepSlider = __webpack_require__(18691);
// EXTERNAL MODULE: ./components/organisms/SupportedCountries/index.js + 1 modules
var SupportedCountries = __webpack_require__(79527);
// EXTERNAL MODULE: ./components/organisms/Wave/index.js
var Wave = __webpack_require__(67370);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/index.js + 2 modules
var WhatMakeUsDifferent = __webpack_require__(58722);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
;// CONCATENATED MODULE: ./common/data/countries.js
var LOCATION_TYPES = {
  AMERICAS: "AMERICAS",
  ASIA_PACIFIC: "ASIA_PACIFIC",
  EMEA: "EMEA"
};
var TAX_RATE_TYPES = {
  ZERO: "ZERO",
  LOW: "LOW"
};
var countries = [{
  id: 1,
  label: "Anguilla",
  value: "Anguilla",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/anguilla",
  icon: "ai",
  zeroCount: 0
}, {
  id: 2,
  label: "Bahamas",
  value: "Bahamas",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/bahamas",
  icon: "bs",
  zeroCount: 1
}, {
  id: 3,
  label: "Belize",
  value: "Belize",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/belize",
  icon: "bz",
  zeroCount: -1
}, {
  id: 4,
  label: "British Virgin Islands",
  value: "British Virgin Islands",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/bvi",
  icon: "vg",
  zeroCount: 2
}, {
  id: 5,
  label: "Cayman Islands",
  value: "Cayman Islands",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/cayman-islands",
  icon: "ky",
  zeroCount: 3
}, {
  id: 6,
  label: "Delaware (the US)",
  value: "Delaware (the US)",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/delaware",
  icon: "us",
  zeroCount: 4
}, {
  id: 7,
  label: "Panama",
  value: "Panama",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/panama",
  icon: "pa",
  zeroCount: 8
}, {
  id: 8,
  label: "St. Kitts & Nevis",
  value: "St. Kitts & Nevis",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/saint-kitts-and-nevis",
  icon: "kn",
  zeroCount: 11
}, {
  id: 9,
  label: "St. Vincent & Grenadines",
  value: "St. Vincent & Grenadines",
  location: LOCATION_TYPES.AMERICAS,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/saint-vincent-and-grenadines",
  icon: "vc",
  zeroCount: 12
}, {
  id: 10,
  label: "Hong Kong",
  value: "Hong Kong",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/hong-kong",
  icon: "hk",
  zeroCount: -1
}, {
  id: 11,
  label: "Marshall Islands",
  value: "Marshall Islands",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/marshall-islands",
  icon: "mh",
  zeroCount: 6
}, {
  id: 12,
  label: "Samoa",
  value: "Samoa",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/samoa",
  icon: "ws",
  zeroCount: 9
}, {
  id: 13,
  label: "Singapore",
  value: "Singapore",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/singapore",
  icon: "sg",
  zeroCount: -1
}, {
  id: 14,
  label: "Vietnam",
  value: "Vietnam",
  location: LOCATION_TYPES.ASIA_PACIFIC,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/vietnam",
  icon: "vn",
  zeroCount: -1
}, {
  id: 15,
  label: "Cyprus",
  value: "Cyprus",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/cyprus",
  icon: "cy",
  zeroCount: -1
}, {
  id: 16,
  label: "Jersey",
  value: "Jersey",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/jersey",
  icon: "je",
  zeroCount: 5
}, {
  id: 17,
  label: "Mauritius",
  value: "Mauritius",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/mauritius",
  icon: "mu",
  zeroCount: 7
}, {
  id: 18,
  label: "Seychelles",
  value: "Seychelles",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/seychelles",
  icon: "sc",
  zeroCount: 10
}, {
  id: 19,
  label: "Ras Al Khaimah (UAE)",
  value: "Ras Al Khaimah (UAE)",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.ZERO,
  href: "/company-formation/rak",
  icon: "ae",
  zeroCount: 13
}, {
  id: 20,
  label: "United Kingdom",
  value: "United Kingdom",
  location: LOCATION_TYPES.EMEA,
  taxRate: TAX_RATE_TYPES.LOW,
  href: "/company-formation/united-kingdom",
  icon: "gb",
  zeroCount: -1
}];
// EXTERNAL MODULE: ./components/atoms/Icon/hi/HiChevronDoubleRight.js
var HiChevronDoubleRight = __webpack_require__(23534);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/company-formation/OurPricing/OurPricingTable/index.js

var _excluded = ["data"];










var MobilePricing = function MobilePricing(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
      data: data.map(function (item) {
        return item.place;
      }),
      tabListClass: {
        display: "flex justify-start md:justify-center",
        border: "border-0",
        padding: "px-1 py-3",
        length: "w-full",
        othersClass: "whitespace-nowrap overflow-x-auto"
      },
      tabClass: {
        padding: "px-6 py-2"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
        className: "shadow-bbc mt-6 rounded-3xl bg-white py-6 px-5",
        children: data.map(function (place, idx) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
            className: "focus:outline-none focus:outline-0 focus:ring-0",
            as: "div",
            children: place.countries.map(function (country, countryIdx) {
              var _countries$find, _countries$find2;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "border-b py-5 first:pt-0 last:border-0 last:pb-0",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex justify-between",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                      src: "/assets/flags/1x1/".concat((_countries$find = countries.find(function (item) {
                        return item.icon === country.icon;
                      })) === null || _countries$find === void 0 ? void 0 : _countries$find.icon, ".svg"),
                      width: 24,
                      height: 24,
                      className: "mr-3 min-h-[24px] min-w-[24px] rounded-full",
                      alt: (_countries$find2 = countries.find(function (item) {
                        return item.icon === country.icon;
                      })) === null || _countries$find2 === void 0 ? void 0 : _countries$find2.icon
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                      href: country.uri || "",
                      target: "_blank",
                      rel: "noreferrer",
                      className: "hover:text-bbc-brand-500 ",
                      children: country.name
                    })]
                  }), country.contact_us && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                      href: country.contact_us || "",
                      target: "_blank",
                      rel: "noreferrer",
                      className: "hover:text-bbc-brand-500  ",
                      children: "Contact us for details"
                    })
                  })]
                }), !country.contact_us && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mt-5",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "mb-2.5 flex justify-between",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: "First year fee"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: country.year_fee
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "mb-2.5 flex justify-between",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: "Annual fee *"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: country.annual_fee
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: "Package Details"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
                        rel: "noreferrer",
                        href: country.package_details || "",
                        target: "_blank",
                        className: "group hover:text-bbc-brand-500 ",
                        children: ["See more", /*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronDoubleRight/* HiChevronDoubleRight */.i, {
                          className: "relative right-0 ml-1 inline-block transition-all duration-100 ease-in-out group-hover:-right-0.5"
                        })]
                      })
                    })]
                  })]
                })]
              }, countryIdx);
            })
          }, idx);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("em", {
      className: "mt-6 block px-7  text-sm leading-6",
      children: ["* Annual fee does not include annual economic substance filing if there is any", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "** All-inclusive Belize annual fee includes compliance fee, ES filing, and annual tax return filing. Please feel free to contact us for the pricing details."]
    })]
  });
};

var OurPricingTable = function OurPricingTable(_ref2) {
  var data = _ref2.data,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var renderTbody = data.length > 0 && data.map(function (item, itemIdx) {
    return Array.isArray(item.countries) && item.countries.length > 0 && item.countries.map(function (tableItem, index) {
      var _countries$find3, _countries$find4, _tableItem$contact_us;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
        className: "".concat(itemIdx % 2 === 0 ? "bg-white" : "bg-bbc-brand-100", "  text-sm  leading-6 "),
        children: [index == 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
          className: "pl-7 pr-6 font-medium leading-6 text-bbc-brand-800 ",
          rowSpan: item.countries.length,
          children: item.place
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
          className: " flex py-1.5 text-left",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
            src: "/assets/flags/1x1/".concat((_countries$find3 = countries.find(function (item) {
              return item.icon === tableItem.icon;
            })) === null || _countries$find3 === void 0 ? void 0 : _countries$find3.icon, ".svg"),
            width: 24,
            height: 24,
            className: "mr-3 rounded-full",
            alt: (_countries$find4 = countries.find(function (item) {
              return item.icon === tableItem.icon;
            })) === null || _countries$find4 === void 0 ? void 0 : _countries$find4.icon
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            rel: "noreferrer",
            href: tableItem.uri || "",
            target: "_blank",
            className: "hover:text-bbc-brand-500 ",
            children: tableItem.name
          })]
        }), ((_tableItem$contact_us = tableItem.contact_us) === null || _tableItem$contact_us === void 0 ? void 0 : _tableItem$contact_us.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
          colSpan: "3",
          className: "text-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
            rel: "noreferrer",
            href: tableItem.contact_us || "",
            target: "_blank",
            className: "hover:text-bbc-brand-500  ",
            children: "Contact us for details"
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            children: tableItem.year_fee
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            children: tableItem.annual_fee
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LinkRouter/* default */.Z, {
              rel: "noreferrer",
              href: tableItem.package_details || "",
              target: "_blank",
              className: "group hover:text-bbc-brand-500 ",
              children: ["See more", /*#__PURE__*/(0,jsx_runtime.jsx)(HiChevronDoubleRight/* HiChevronDoubleRight */.i, {
                className: "relative right-0 ml-1 inline-block transition-all duration-100 ease-in-out group-hover:-right-0.5"
              })]
            })
          })]
        })]
      }, index);
    });
  });

  var _useState = (0,react.useState)(["", "Jurisdictions", "First year fee", "Annual fee *", "Package Details"]),
      theadArr = _useState[0];

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: props.className,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "overflow-hidden rounded-2xl border border-bbc-neutral-400 bg-white pb-[22px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
        className: "w-full ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
          className: "border-b ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
            className: "bg-bbc-brand-700 ",
            children: theadArr.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                className: "py-4 text-left text-sm font-medium leading-6 text-white",
                children: item
              }, index);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
          children: renderTbody
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("em", {
        className: "mt-4 block px-7  text-sm leading-6",
        children: ["* Annual fee does not include annual economic substance filing if there is any", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "** All-inclusive Belize annual fee includes compliance fee, ES filing, and annual tax return filing. Please feel free to contact us for the pricing details."]
      })]
    })
  });
};

/* harmony default export */ var OurPricing_OurPricingTable = (OurPricingTable);
OurPricingTable.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
};
;// CONCATENATED MODULE: ./components/templates/offshore/company-formation/OurPricing/data.json
var data_namespaceObject = JSON.parse('{"y":[{"place":"Africa","countries":[{"icon":"mu","name":"Mauritius (AC)","uri":"/company-formation/mauritius","year_fee":"1,999","annual_fee":"1,849","package_details":"/company-formation/mauritius","contact_us":""},{"icon":"sc","name":"Seychelles","uri":"/company-formation/seychelles","year_fee":"669","annual_fee":"649","package_details":"/company-formation/seychelles","contact_us":""}]},{"place":"Americas","countries":[{"icon":"ai","name":"Anguilla","uri":"/company-formation/anguilla","year_fee":"899","annual_fee":"859","package_details":"/company-formation/anguilla","contact_us":""},{"icon":"bs","name":"Bahamas","uri":"/company-formation/bahamas","year_fee":"1,539","annual_fee":"1,459","package_details":"/company-formation/bahamas","contact_us":""},{"icon":"bz","name":"Belize","uri":"/company-formation/belize","year_fee":"1,059","annual_fee":"1,399**","package_details":"/company-formation/belize","contact_us":""},{"icon":"vg","name":"British Virgin Islands","uri":"/company-formation/bvi","year_fee":"1,299","annual_fee":"1,259","package_details":"/company-formation/bvi","contact_us":""},{"icon":"ky","name":"Cayman Islands (Exempt)","uri":"/company-formation/cayman-islands","year_fee":"2,699","annual_fee":"2,799","package_details":"/company-formation/cayman-islands","contact_us":""},{"icon":"us","name":"Delaware (the US)","uri":"/company-formation/delaware","year_fee":"439","annual_fee":"199 (plus gov. levy)","package_details":"/company-formation/delaware","contact_us":""},{"icon":"kn","name":"St. Kitts and Nevis","uri":"/company-formation/saint-kitts-and-nevis","year_fee":"1,369","annual_fee":"1,349","package_details":"/company-formation/saint-kitts-and-nevis","contact_us":""},{"icon":"pa","name":"Panama","uri":"/company-formation/panama","year_fee":"1,249","annual_fee":"1,149","package_details":"/company-formation/panama","contact_us":""},{"icon":"vc","name":"St. Vincent and Grenadines","uri":"/company-formation/saint-vincent-and-grenadines","year_fee":"1,099","annual_fee":"999","package_details":"/company-formation/saint-vincent-and-grenadines","contact_us":""}]},{"place":"Asia","countries":[{"icon":"ae","name":"Ras Al Khaimah","uri":"/company-formation/rak","year_fee":"2,699","annual_fee":"2,520","package_details":"/company-formation/rak","contact_us":""}]},{"place":"Europe","countries":[{"icon":"cy","name":"Cyprus","uri":"/company-formation/cyprus","year_fee":"1,899","annual_fee":"1,399","package_details":"/company-formation/cyprus","contact_us":""},{"icon":"gb","name":"United Kingdom","uri":"/company-formation/united-kingdom","year_fee":"549","annual_fee":"499","package_details":"/company-formation/united-kingdom","contact_us":""}]},{"place":"Oceania","countries":[{"icon":"mh","name":"Marshall Islands (IBC)","uri":"/company-formation/marshall-islands","year_fee":"929","annual_fee":"909","package_details":"/company-formation/marshall-islands","contact_us":""},{"icon":"ws","name":"Samoa","uri":"/company-formation/samoa","year_fee":"929","annual_fee":"899","package_details":"/company-formation/samoa","contact_us":""}]}]}');
;// CONCATENATED MODULE: ./components/templates/offshore/company-formation/OurPricing/index.js






var OurPricing = function OurPricing() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OurPricing_OurPricingTable, {
        data: data_namespaceObject.y
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "block lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MobilePricing, {
        data: data_namespaceObject.y
      })
    })]
  });
};

/* harmony default export */ var company_formation_OurPricing = (OurPricing);
OurPricing.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
};
;// CONCATENATED MODULE: ./components/templates/offshore/company-formation/VideoPlayer/index.js


/**
 *
 * @param {{
 * }} props Props for the component
 *
 */




var VideoPlayer = function VideoPlayer() {
  var _useState = (0,react.useState)(false),
      isPlayed = _useState[0],
      setIsPlayed = _useState[1];

  var handleOnClickPlay = function handleOnClickPlay() {
    setIsPlayed(true);
  };

  if (isPlayed) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
      src: "https://www.youtube.com/embed/8RkJwKEXKPU?start=32;rel=0&autoplay=1",
      width: "540",
      height: "381",
      frameBorder: "0",
      title: "BBCIncorp Client Portal - Bring your next business venture online",
      allow: "accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture",
      allowFullScreen: true,
      className: " w-full"
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative overflow-hidden rounded-2xl",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      src: "/assets/images/offshore/company-formation/offshore-company-formation-video-thumbnail.png",
      wrapper: {
        className: "block"
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 z-20 flex h-full w-full items-center justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "block w-1/4 ",
        onClick: handleOnClickPlay,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/offshore/company-formation/icon-play.png",
          wrapper: {
            className: ""
          },
          className: "transition-transform duration-150 hover:scale-110"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 z-10 flex h-full w-full items-end p-4 sm:p-9",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: " font-bold leading-tight  text-bbc-white sm:leading-10",
        style: {
          fontSize: "min(5vw, 36px)"
        },
        children: ["Bring your next", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " business venture online"]
      })
    })]
  });
};

/* harmony default export */ var company_formation_VideoPlayer = (VideoPlayer);
;// CONCATENATED MODULE: ./components/templates/offshore/company-formation/index.js























var NewsSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 5593).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/offshore/company-formation/index.js -> " + "components/organisms/NewsSlider"]
  }
});
/** ========== */

var OffshoreCompanyFormation = function OffshoreCompanyFormation(_ref) {
  var _dataJson$dataHowItWo, _dataJson$dataHowItWo2;

  var data = _ref.data,
      dataJson = _ref.dataJson;
  (0,react.useLayoutEffect)(function () {
    if (window.location.hash) {
      setTimeout(function () {
        var id = window.location.hash.replace("#", "");
        var scrollToTable = document.getElementById(id).getBoundingClientRect();
        window.scrollTo({
          top: scrollToTable.top + window.pageYOffset - 86,
          behavior: "smooth"
        });
      }, 100);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: "Offshore Company Formation",
      titleProps: {
        className: "banner-default-title mb-10",
        textColor: "banner-title-gradient-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/company-formation/banner-offshore-formation.png",
        wrapper: {
          className: "bbc-banner-image-country pb-8 lg:pb-0"
        },
        className: "h-full w-full",
        width: 650,
        height: 480,
        alt: "offshore company formation with the help of technology"
      }),
      bgColor: "bg-bbc-gradient-service",
      dataTrustpilot: {
        dataStatic: dataJson.dataTrustpilot,
        dataDefault: data.dataTrustpilot
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-10 m-auto ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-4 text-center  text-bbc-brand-800 lg:mb-10 ",
            children: "Quick Offshore Company Formation With Client Portal"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row flex-col-reverse items-center lg:flex-row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 lg:col-6  ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Setting up an international business company can be tough. "
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "You're forced to brave through layers of complex local laws and corporate governance guidelines only to struggle to stay on top of it all in the end."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "But what if there's another way to approach this? One that allows you to"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "list-disc pt-4\tpl-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-2",
                children: "Fast-track your formation process"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-2",
                children: "Be in control of all compliance related matters"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "pb-2",
                children: "Stay on top of any law changes"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "This is where we come in."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 mb-6 lg:col-6 lg:mb-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_formation_VideoPlayer, {})
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SupportedCountries/* default */.Z, {
      id: "company-registration",
      title: "Company Registration Worldwide",
      description: "Set up your business in over +15 countries and receive consultations from our local experts.",
      data: dataJson.supportedCountries,
      descriptionBottom: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-center text-bbc-white ",
        children: ["Not sure where to go offshore ?", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return Tawk_API.toggle();

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })),
          className: "ml-2 inline-block cursor-pointer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "  text-bbc-secondary-300 ",
            children: "Talk to our experts"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider["default"], {
          thetitle: "Typical use of an offshore company",
          description: "An offshore company can be flexible with various business industries.",
          showPaginationClass: "lg:visible lg:pt-4",
          pagination: {
            el: ".bbc-slide-pagination",
            clickable: true,
            bulletClass: "bbc-pagination-bullet",
            bulletActiveClass: "bg-bbc-brand-700 opacity-100"
          },
          children: Array.isArray(dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataOffshoreSlider) && (dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataOffshoreSlider.length) > 0 && (dataJson === null || dataJson === void 0 ? void 0 : dataJson.dataOffshoreSlider.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              className: "!h-auto py-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: " h-full w-full rounded-3xl bg-white shadow-[0px_16px_40px_rgba(181,181,181,0.25)]",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-4 pt-6",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: item.img_src,
                    alt: "a",
                    wrapper: {
                      className: "w-full"
                    },
                    className: "m-auto aspect-[16/9] h-20 w-20 rounded-t-3xl object-cover"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "px-6 pb-8",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                    as: "h3",
                    className: "text-center text-lg font-semibold text-bbc-brand-700 line-clamp-2",
                    children: item === null || item === void 0 ? void 0 : item.title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mt-2",
                    dangerouslySetInnerHTML: {
                      __html: item === null || item === void 0 ? void 0 : item.description
                    }
                  })]
                })]
              })
            }, index);
          }))
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: " text-center lg:pt-6",
          children: ["Need more resources?", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonNew/* default */.Z, {
            as: "a",
            className: "font-medium text-bbc-brand-500",
            target: "_blank",
            useRouter: true,
            href: "/guide-and-tool/offshore-company-comparison",
            children: ["This page", " "]
          }), "helps you out."]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wave/* Wave */.i, {
      background: "lg:bg-bbc-brand-100",
      srcTop: "/assets/images/offshore/company-formation/w1-offshore-formation.svg",
      srcBottom: "/assets/images/offshore/company-formation/w2-offshore-formation.svg",
      heightBottom: " h-4/5 ",
      sectionTop: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "m-auto lg:col-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
          title: "Wonder how an offshore company fits your plan?",
          descriptionClass: "mb-6 lg:mb-10 text-center",
          contentBottom: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "row mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "justify-center lg:flex",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "border-r border-bbc-gray pr-4 ",
                  children: "Non-Obligatory Consultation"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "lg:pl-4 ",
                  children: "Highly Responsive Reps"
                })]
              })
            })
          }),
          description: "Just leave your questions here, and we will get back within 2 hrs."
        })
      }),
      sectionBottom: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " container",
        id: "PriceTable",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          as: "h2",
          className: "mb-6 text-center text-3xl font-semibold  capitalize text-bbc-brand-800 lg:text-bbc-40px",
          children: "Our pricing"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(company_formation_OurPricing, {})]
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "py-10 lg:py-20",
        children: dataJson.dataRegistrationStep && typeof dataJson.dataRegistrationStep === "object" && Object.keys(dataJson.dataRegistrationStep).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(StepSlider["default"], {
          data: dataJson.dataRegistrationStep,
          className: "mx-auto pt-0 lg:pt-0",
          title: dataJson.dataRegistrationStep.title,
          description: dataJson.dataRegistrationStep.description,
          imgAlt: dataJson.dataRegistrationStep.alt
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "pb-10 lg:pb-20",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent/* default */.Z, {
          title: "Bring your next business venture online",
          data: dataJson.dataWhatMakeUsDifferent,
          className: "bg-wmud py-[60px] capitalize"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "pb-10 lg:pb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
              as: "h2",
              className: "mb-6 text-center text-3xl font-semibold  capitalize text-bbc-brand-800 lg:text-bbc-40px",
              children: "How it works with BBCIncorp"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "col-12 m-auto text-center lg:col-9",
              children: "From making incorporation decisions, creating order to managing incorporation process, we add value along your incorporation journey."
            })]
          }), ((_dataJson$dataHowItWo = dataJson.dataHowItWorks) === null || _dataJson$dataHowItWo === void 0 ? void 0 : _dataJson$dataHowItWo.length) > 0 && ((_dataJson$dataHowItWo2 = dataJson.dataHowItWorks) === null || _dataJson$dataHowItWo2 === void 0 ? void 0 : _dataJson$dataHowItWo2.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "col-12 mt-6 lg:col-4 lg:mt-10",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500 lg:mb-10",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                className: "mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-bbc-gray",
                children: item.content
              })]
            }, index);
          }))]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
        title: "Required Documents",
        data: dataJson.dataRequiredDocument,
        backgroundImage: "/assets/images/common/required-documents.png",
        sectionClassName: "py-10 lg:py-20 "
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z // Description="Get your answers from commonly asked questions."
          , {
            title: "Frequently Asked Questions",
            data: dataJson.dataFaqs
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var company_formation = (OffshoreCompanyFormation);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/data.json
var company_formation_data_namespaceObject = JSON.parse('{"breadcrumbs":[{"id":1,"uri":"/","title":"Home"},{"id":1,"uri":"/company-formation","title":"Offshore Company Formation"}],"dataTrustpilot":{"content":{"link_button_placeholder":"/guide-and-tool/offshore-company-comparison","button_placeholder":"Compare Jurisdictions","rel_placeholder":"noopener noreferrer","target_placeholder":"_blank","benefits":["Online company registration","Remote bank account opening","Dedicated support"],"see_package":"or Discover our pricing","see_package_id":"PriceTable"}},"supportedCountries":[{"label":"The Americas","value":"the-americas","listCountries":[{"text":"Anguilla","uri":"/company-formation/anguilla"},{"text":"Bahamas","uri":"/company-formation/bahamas"},{"text":"Belize","uri":"/company-formation/belize"},{"text":"British Virgin Islands","uri":"/company-formation/bvi"},{"text":"Cayman Islands","uri":"/company-formation/cayman-islands"},{"text":"Delaware (US)","uri":"/company-formation/delaware"},{"text":"Panama","uri":"/company-formation/panama"},{"text":"St. Kitts & Nevis","uri":"/company-formation/saint-kitts-and-nevis"},{"text":"St. Vincent & Grenadines","uri":"/company-formation/saint-vincent-and-grenadines"}]},{"label":"Asia Pacific","value":"asia-pacific","listCountries":[{"text":"Marshall Islands","uri":"/company-formation/marshall-islands"},{"text":"Samoa","uri":"/company-formation/samoa"}]},{"label":"Europe, Middle East and Africa (EMEA)","value":"emea","listCountries":[{"text":"Cyprus","uri":"/company-formation/cyprus"},{"text":"Mauritius","uri":"/company-formation/mauritius"},{"text":"Seychelles","uri":"/company-formation/seychelles"},{"text":"Ras AI Khaimah (UAE)","uri":"/company-formation/rak"},{"text":"United Kingdom","uri":"/company-formation/united-kingdom"}]}],"dataOffshoreSlider":[{"title":"e-Commerce","description":"<p class=\'mb-4\'>e-Commerce businesses typically benefit the most from an offshore structure as they\'re not tied down by any physical bounds. Yet selecting a proper offshore jurisdiction requires a well-thought plan due to sales tax, payment processing gateway and hosting consideration for place of business issue.</p>","img_src":"/assets/images/offshore/company-formation/icon-e-commerce.svg"},{"title":"International trading","description":"<p class=\'mb-4\'>Like e-commerce industry, international trading finds an offshore structure highly potential as it involves cross-border transactions. Two critical things, among other issues that should be factored into account include PE establishment and transfer pricing rules.</p>","img_src":"/assets/images/offshore/company-formation/icon-international-trading.svg"},{"title":"IP Holding","description":"<p class=\'mb-4\'>A company structure holding IP assets like patents, trademarks often situate in a jurisdiction with low to none corporate income tax, having favourable tax treatment on royalties and payment of dividend. Beyond tax, the country should have a strong legal framework for IP protection.</p>","img_src":"/assets/images/offshore/company-formation/icon-ip-holding.svg"},{"title":"Consultants/Counsellors","description":"<p class=\'mb-4\'>Tax reduction is usually the main motivation for professional practitioners when they come to offshore company. This helps defer the income tax or negate them all if the plan involves renunciation of citizenship. Jurisdiction reputation is also an important factor to help their clients claim expense deduction and avoid unnecessary inquiry from the Authority.</p>","img_src":"/assets/images/offshore/company-formation/icon-consultants.svg"},{"title":"Holding company for shares, real estate","description":"<p class=\'mb-4\'>An offshore investment holding structure helps separate business from personal assets, thus create a layer of assurance in case of a lawsuit. Plus, it allows greater flexibility to approach multi types of assets to attain diversification. Some jurisdictions even have advantageous legislation to passive holding.</p>","img_src":"/assets/images/offshore/company-formation/icon-holding-company.svg"},{"title":"Wealth succession planning","description":"<p class=\'mb-4\'>Trust, Foundation or other specialized structures like Private Trust Company, Offshore Family Investment Company are widely used in the private wealth management industry. These types allow deliberate tax planning and wealth succession for the next generations.</p>","img_src":"/assets/images/offshore/company-formation/icon-wealth-succession.svg"},{"title":"Broker/Forex/Coin trading","description":"<p class=\'mb-4\'>Offshore states are known to have a more liberal stance on digital assets which makes them ideal destinations for blockchain-related ventures. The perks often come in the form of a more open or less regulated market where conditions about license or capital are rarely a problem for participants like sole trader, broker or private investment fund.</p>","img_src":"/assets/images/offshore/company-formation/icon-broker-forex-coin.svg"},{"title":"International business expansion for tax purpose ","description":"<p class=\'mb-4\'>Whether overseas expansion plan bases off tax issues or not, a successful going global strategy will definitely entail tax consideration outright. This would include a complete review of the overall group structure to validate or challenge the existence of some current entities and establishment of new location presence to reach a more preferable tax position.</p>","img_src":"/assets/images/offshore/company-formation/icon-international-business.svg"}],"dataRegistrationStep":{"title":"Register your company in just 4 steps","description":"Things are likely to go awry if you can\'t arrange thoroughly before starting your offshore business venture. Explore your roadmap to offshore company with following series of steps","image":"/assets/images/offshore/country/bvi/bank_account-bvi.png","alt":"steps to register an offshore company","steps":[{"index":"Step 1: ","titleStep":"Determine the right legal business entity","description":"<p>Uncertain about whether Limited (Ltd), Limited Liability Company (LLC), or International Business Company (IBC) should be your wise choice? Our friendly consultants are awaiting to share with you practical advice.</p>"},{"index":"Step 2:","titleStep":"Choose the company name","description":"Rule of thumb is your company name must be unique. And each offshore jurisdiction may impose different naming requirements."},{"index":"Step 3:","titleStep":"Legalize your company registration","description":"<p>You\'ll have to register for business licenses and certain permits with the licensing agency to bring your company into legal operation, depending on your business type and registration jurisdiction.</p>"},{"index":"Step 4:","titleStep":"Open a business account","description":"<p>The management of all business transactions requires a business account. You can obtain the account with a bank or fintech solutions as the alternative.</p>"}]},"dataWhatMakeUsDifferent":[{"title":"Streamlined process","description":"Start at your own pace. And reduce waiting time for back-and-forth email communication.","img_src":"/assets/images/common/process-wmud.png"},{"title":"E-signature","description":"Collaborate with your partner more easily. Less paperwork, more efficiency.","img_src":"/assets/images/common/e_signature-wmud.png"},{"title":"Digitized KYC","description":"Standardized form & organizational chart to let you control and declare your information effortlessly.","img_src":"/assets/images/common/kyc-wmud.png"},{"title":"Centralized management portal","description":"24/7 access to company documents on high-security cloud infrastructure. And no worry about key compliance deadlines with auto reminder.","img_src":"/assets/images/common/portal-wmud.png"}],"dataHowItWorks":[{"title":"Understanding your case","content":"Our developed in-house consultants with relevant experience in corporate formation will assist you to determine and clearly set out your business goals and conditions. With that information, we help you choose the right plan that could satisfy your needs in an effective manner."},{"title":"Knowing your client (KYC)","content":"Based on a unified agreement, we will collect the required customer\'s documents and verify them with signed order and due diligence forms. Our digital Client Portal is tailor-made for client\'s enhanced experience while using our services. You\'ll log in and can proceed with the incorporation steps and keep track of the process anytime, anywhere."},{"title":"Incorporation process","content":"The order form will be passed through the compliance department and the company registrar for incorporation. Depending on each country, the time needed to obtain the hard copies of company documents could be as short as 1 hour to a couple of working days."},{"title":"Post-registration services","content":"A successful registration of offshore company is only the first step to achieve your goal. You might need to open a bank account for trading with your partners. Depending on your selected package, we will continue to assist you with additional services to get your company ready for doing business."}],"dataRequiredDocument":{"button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"Each country might have different requirements of the documents for setting up a company, but below information will give you a good reference to start with.","listContent":[{"text":"Scan of notarized passport of all shareholder(s)/director(s)/beneficial owner(s);","content":[]},{"text":"Scan of notarized address proof of all shareholder(s)/director(s))/beneficial owner(s);","content":[]}]},{"title":"All needed to be dated within 3 months."}]},"dataFaqs":[{"name":"What is an offshore company?","content":"<div class=\\"content\\"><p>In business context, \\"offshore\\" is associated with a jurisdiction out of the home land where has more beneficial conditions. An offshore company is often attached to many advantages such as favorable tax, asset protection, business privacy, etc. Moreover, some jurisdictions will have special programs and laws to encourage the growth of certain business sectors.</p><p>Starting or moving your business offshore will require you to register the business in the country of registration, which is called \\"offshore company formation\\". The regulations and requirements will vary by the jurisdiction. However, most offshore countries have relaxing laws to welcome entrepreneurs around the world to land their businesses within the borders. Each country will have various business structures you can choose from. Common structures are International Business Comany (IBC), Corporation, Business Company (BC), Limited Liability Company (LLC).</p></div>"},{"name":"Who should use an offshore company?","content":"<div class=\\"content\\"><p>Businessmen/ Digital entrepreneurs:<br/>With an offshore company, you can begin an activity without the need to deal with the setup of complicated infrastructure and reap tons of benefits from offshore jurisdictions.<br/>Digital entrepreneurs are one of the main groups to fit in an offshore company. This group don\'t have a fixed addresses or business offices. They facilitate the digital platforms to start and grow their businesses. They prefer the simple online incorporation, minimal tax reporting requirements that can save their budget. And offshore companies meet their criteria.</p><p>Ecommerce business:<br/>One of offshore company\'s key features is flexibility and simple setup, which is a good facilitator of those whose business is on the Internet, maintain domain and manage sites. Another advantage is tax optimization for online businesses. Sales tax is the top concerning issue when operating an online business. Typically, some offshore jurisdictions don\'t collect sales tax for the purchasing whithin the borders.</p><p>Consultants / Counsellors:<br/>Simple administration and high level of privacy make offshore company incorporation a great choice for consulting businesses.</p><p>Trading business:<br/>International trading companies are often connected with offshore company structure thanks to its versatile nature.</p><p>Holding business:<br/>Holding company does not engage in any trading activities but is established to hold shares or assets of other companies. An offshore company has various uses, for example reducing withholding tax, increasing asset protection, and enhancing privacy, so it is considered preferred choice for holding or IP holding company.</p><p>Forex/crypto based business:<br/>Another group that suits to start a company offshore is stockbroker or forex service provider. Most offshore jurisdictions have great asset protection laws and corporate anonymity. Besides, some offshore jurisdictions have friendly environment and strong financial services that are ideal starting the related businesses.</p></div>"},{"name":"Is it actually legal to own an offshore company?","content":"<div class=\\"content\\"><p>Yes. It is legal for you to own an offshore company. The problem is that you just need to follow the regulations set out by the country of company registration. Such regulations can be tax filing, annual reports and other ongoing obligations.</p></div>"},{"name":"Are offshore companies safe?","content":"<p>Tax is the most concerning matter when it comes to starting an offshore company. Most countries will try to optimize the taxable amount for foreign businesses to encourage the company registration. The downside is that some countries have excessively favorable regulations that potentially lead to tax evasion, or illegal tax avoidance.</p><p>Thus, offshore businesses usually must comply with additional tax reports following Foreign Account Tax Compliance Act (FATCA), or requirements set out by the Organization for Economic Cooperation and Development (OECD) and the World Trade Organization (WTO). European Union (EU) also has a list of non-cooperative tax jurisdictions for tax purposes. The countries that are in the scope must apply regulations on businesses to ensure the tax transparency.</p><p>If you register your offshore company with a jurisdiction, your business has legal protection. So the answer is \\"Offshore companies are safe\\" as soon as you comply with the related requirements, especially tax reporting regulations. So do reasearch carefully the applicable requirements of your business to make sure your company stay compliant.</p>"},{"name":"What are the purposes of the offshore company?","content":"<p>The main reason for starting an offshore company is to enjoy more favorable conditions. Such conditions can be tax advantages, simple incorporation, beneficial environment for specific types of businesses.</p><p>Some business owners, especially owners of big firms, want to have an offshore company to hold their intangible assets such as intellectual property for tax purposes. They can cut down the amount of business taxes by using transfer pricing for their offshore company.</p>"},{"name":"What are the advantages of using an offshore company?","content":"<p>There is no limits to the benefits of an offshore company. Governments of offshore countries constantly update business trends and keep their laws and supportive programs up-to-date. Below are advantages you can find in many offshore countries:</p><ul><li>High level of corporate privacy and assest protection</li><li>Easy and simple incorporation process</li><li>Favorable tax conditions</li><li>Minimal reporting requirements</li></ul>"},{"name":"Which is the best country for offshore company registration?","content":"<p>Best <a href=\\"/offshore/articles/best-offshore-company-jurisdictions#2-examples-of-best-offshore-jurisdictions-for-foreigners\\" target=\\"_blank\\">offshore company jurisdiction</a> is the one that fits your business needs. Over 40 countries encourages overseas investors to start offshore company within the borders. Each of them has distinct and competitive features to magnitize entrepreneurs around the world. Thus, considering the following impactful factors for choosing the best one:</p><ul><li>How you want your company is taxed;</li><li>Where your customers are located;</li><li>What type of products and services you are planning to sell; and</li><li>How your prefer cost, service speed and range of related services of the incorporation to be.</li></ul><p>There are still other considerations for the offshore country selection depending on your specific situation.</p>"},{"name":"What are tips for choosing an ideal incorporation jurisdiction?","content":"<p>Below are some tips to help you determine an offshore jurisdiction that excellently fits your business needs:</p><ul><li>The country profile: The stability of economy and politics from high-profile countries provides the potential for your business growth.</li><li>Country of residency: Where you live will affect to the eligibility of offshore company registration.</li><li>Tax regime: Take time to examine tax rates that may apply to your business and exemption cases (if any). Chances are business owners could save money by operating in a low-tax or even no income tax jurisdictions.</li><li>High-risk or low-risk list: Be aware if your chosen offshore jurisdiction is in the \\"red\\" list namely EU list of non-cooperative tax countries, US sanctioned countries. This will affect to your business trading or expanding plan.</li></ul><p><a href=\\"/offshore/articles/best-offshore-company-jurisdictions\\" target=\\"_blank\\">Find out more</a></p>"},{"name":"What is the difference between an international business company (IBC) and LLC?","content":"<p>An international business company (IBC) is a type of legal entity that is often used for international business transactions. IBCs are typically incorporated in offshore jurisdictions and offer various benefits, such as low taxation and limited regulation.</p><p>An LLC, on the other hand, is a type of legal entity that is typically used for domestic businesses. LLCs are typically incorporated in the United States and offer various benefits, such as pass-through taxation and limited liability.</p><p>So, what is the difference between an IBC and LLC? Well, the main difference is that an IBC is typically used for international business transactions while an LLC is typically used for domestic businesses. Additionally, IBCs are typically incorporated in offshore jurisdictions while LLCs are typically incorporated in the United States. Finally, IBCs offer various benefits, such as low taxation and limited regulation, while LLCs offer different benefits, such as pass-through taxation and limited liability.</p>"},{"name":"How do I register for international business?","content":"<p>To register your business for international trade, you will need to follow a few simple steps. First, you will need to choose a business structure that is right for your company. You will then need to obtain the necessary licenses and permits from the government. Finally, you will need to have your company\'s financial information in order. Once you have all of this information, you will be ready to begin the registration process yourself or use a company formation service to expedite it.</p>"}]}');
;// CONCATENATED MODULE: ./pages/offshore/company-formation/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_formation, {
        data: data,
        dataJson: company_formation_data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 99353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation",
      function () {
        return __webpack_require__(60917);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31857:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"Index_btn___obRs","btnPrev":"Index_btnPrev__kxfmc","btnNext":"Index_btnNext__V4iBC"};

/***/ }),

/***/ 81131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line":"Index_line__t7vab"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,4868,4090,9738,7447,9156,477,2888,179], function() { return __webpack_exec__(99353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);